import { ReactElement } from 'react';

interface TableWidgetProps {
  headerNames: string[];
  rows: string[][];
}

const rowTextClass = 'flex-row';
export function TableWidget({ headerNames, rows }: TableWidgetProps): ReactElement {
  return (
    <div className="table-container" role="table">
      <div className="flex-table header" role="rowgroup">
        {createHeaders(headerNames)}
      </div>
      {createRows(rows)}
    </div>
  );
}

function createHeaders(headerNames: string[]): JSX.Element[] {
  return headerNames.map((name, index) => {
    return (
      <div key={index} className={getTableTextAlignmentClass(index, headerNames.length)} role="columnheader">
        {name}
      </div>
    );
  });
}

function createRows(rows: string[][]) {
  return rows.map((row, index) => {
    return (
      <div key={index} className="flex-table row" role="rowgroup">
        {createCells(row)}
      </div>
    );
  });
}

function createCells(row: string[]): JSX.Element[] {
  return row.map((cell, index) => {
    return (
      <div key={index} className={getTableTextAlignmentClass(index, row.length)} role="cell">
        {cell}
      </div>
    );
  });
}

function getTableTextAlignmentClass(cellNumber: number, rowLength: number): string {
  let rowClass = rowTextClass;
  if (cellNumber >= rowLength / 3) {
    rowClass += ' text-right';
  }

  return rowClass;
}
